import { t } from 'i18next';
import { PluginWrapper } from '../../../components/plugins';
import { useUserContext } from '../../../system/providers/userContextProvider';
import { checkLockStatus } from '../../CommonHelperFunctions';
import GoodsDayPhoto from '../../Dictionaries/Goods/components/GoodsDayPhoto';

const ID_GOODS_GLOBAL = '00000000-0000-0000-0000-000000000000';

export const BasePhotoDownloadView = () => {
    const userContext = useUserContext();
    
    const isFileHubLocked = checkLockStatus("FileHubFile" as IPermission, userContext.userPermission);
    const isMarketingLocked = checkLockStatus("ProAptekaMarketing" as IPermission, userContext.userPermission);
        
    const lockFromPermission = isFileHubLocked || isMarketingLocked;
    
    return (
        <PluginWrapper>
            <GoodsDayPhoto
                idGoodsGlobal={ID_GOODS_GLOBAL}
                hasPhoto={true}
                isOpenedAccordion={true}
                lockFromPermission={lockFromPermission}
            />
        </PluginWrapper >
    )
}